import { render, staticRenderFns } from "./persistent-input.vue?vue&type=template&id=2c3e228a&scoped=true"
import script from "./persistent-input.vue?vue&type=script&lang=js"
export * from "./persistent-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e228a",
  null
  
)

export default component.exports